// Module
var code = "<div id=\"V-18D34E32-495A-41DB-92C9-8D0834AD9FE6\"> <div data-b-component=\"dragdrop\" data-b-comp-allowdropinto=\"true\" data-b-comp-isDropInside=\"{Binding isOver}\"> <div class=\"V-18D34E32-495A-41DB-92C9-8D0834AD9FE6\" data-b-class-isover=\"{Binding isOver}\"> </div> </div> </div> ";
// Exports
export default code;